import styles from './required-badge.module.css';

export function RequiredBadge() {
  return <span className={styles.badge}>必須</span>;
}
